export default "__VITE_ASSET__D0o8dH5w__"